/**
 * Pure scan-state helpers for the web charts kit.
 *
 * Chart Layout & Interaction Policy (mobile-design-system skill): scan state
 * is INDEX-keyed, never x-label-keyed — formatted date labels repeat, and
 * label-keyed state freezes on the first match (shipped mobile bug).
 * Recharts reports `activeTooltipIndex` from chart-level pointer events;
 * these helpers normalize it into a bounded numeric index.
 */

/** Recharts reports the active index as number | string | undefined. */
export function parseActiveScanIndex(
  value: unknown,
  pointCount: number,
): number | null {
  const numeric =
    typeof value === "number"
      ? value
      : typeof value === "string" && value.trim() !== ""
        ? Number(value)
        : Number.NaN;
  if (!Number.isInteger(numeric)) return null;
  if (numeric < 0 || numeric >= pointCount) return null;
  return numeric;
}

/**
 * The header is the readout: while scanning it shows the scanned point,
 * at rest the latest point. Returns null only for empty data.
 */
export function resolveHeaderIndex(
  scanIndex: number | null,
  pointCount: number,
): number | null {
  if (pointCount <= 0) return null;
  if (scanIndex !== null && scanIndex < pointCount) return scanIndex;
  return pointCount - 1;
}
